"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapIdFromColumn = void 0;
const mapIdFromColumn = (records, idColumn) => {
    return records.map((record) => {
        return Object.assign(Object.assign({}, record), { id: String(record[idColumn]) });
    });
};
exports.mapIdFromColumn = mapIdFromColumn;
//# sourceMappingURL=Map.js.map